import axios from 'axios';

const basePath = '/api/delivery';

export const tripService = {
  // Obtener ciudades con pedidos pendientes
  getPendingCities: async () => {
    const response = await axios.get(`${basePath}/pending-cities/`);
    return response.data;
  },

  // Obtener pedidos pendientes por ciudad
  getPendingOrdersByCity: async (city) => {
    const response = await axios.get(`${basePath}/pending-orders/`, {
      params: { city },
    });
    return response.data;
  },

  // Obtener pedidos pendientes de todas las ciudades de una ruta (en orden de parada)
  getPendingOrdersByRoute: async (routeId) => {
    const response = await axios.get(`${basePath}/pending-orders/`, {
      params: { route: routeId },
    });
    return response.data;
  },

  // Obtener lista completa de viajes
  getTrips: async (params) => {
    const response = await axios.get(`${basePath}/trips/`, { params });
    return response.data;
  },

  // Obtener detalle de un viaje específico
  getTripDetail: async (id) => {
    const response = await axios.get(`${basePath}/trips/${id}/`);
    return response.data;
  },

  // Crear nuevo viaje
  createTrip: async (tripData) => {
    const response = await axios.post(`${basePath}/trips/`, tripData);
    return response.data;
  },

  // Actualizar estado del viaje
  updateTripStatus: async (id, status) => {
    const response = await axios.patch(`${basePath}/trips/${id}/status/`, { status });
    return response.data;
  },

  // Agregar a mano pedidos pendientes a un viaje en borrador
  addTripOrders: async (id, orderIds) => {
    const response = await axios.post(`${basePath}/trips/${id}/orders/`, { order_ids: orderIds });
    return response.data;
  },

  // Quitar un pedido de un viaje en borrador (vuelve a quedar pendiente)
  removeTripOrder: async (id, orderId) => {
    const response = await axios.delete(`${basePath}/trips/${id}/orders/${orderId}/`);
    return response.data;
  },

  // Obtener datos para la planilla de control
  getTripReport: async (id) => {
    const response = await axios.get(`${basePath}/trips/${id}/report/`);
    return response.data;
  }
};

export default tripService;
